import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { RouteErrorBoundary, RouteSkeleton } from "@/components/ErrorBoundary";
import {
  standaloneRoutes,
  internalLayoutRoute,
} from "@/generated/routes";
import { NotFoundPage } from "@/pages/NotFoundPage";

function withRouteBoundary(element: React.ReactNode) {
  return (
    <RouteErrorBoundary>
      <React.Suspense fallback={<RouteSkeleton />}>{element}</React.Suspense>
    </RouteErrorBoundary>
  );
}

const router = createBrowserRouter([
  ...standaloneRoutes,
  internalLayoutRoute,
  {
    path: "*",
    element: withRouteBoundary(<NotFoundPage />),
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
